import { ChiliPiperService } from '@self-serve/services/calendar/chili-piper.service';
import { FakeCalendarService } from '@self-serve/services/calendar/fake-calendar.service';

const Services = [ChiliPiperService, FakeCalendarService];

export { Services, ChiliPiperService, FakeCalendarService };
